<h4>{{ editing ? 'Edit policy' : 'Add a new policy' }}</h4>
<div class="flex gap-4 items-start">
	<app-radio-group
		orientation="horizontal"
		label="Select a policy type"
		[items]="policyTypeOptions"
		[(ngModel)]="policyType"
	></app-radio-group>
	<app-dropdown
		*ngIf="policyType === titleInsurancePolicyType.LENDER"
		[ngModel]="priority"
		label="Mortgage priority"
		[itemGroups]="[{ items: priorityOptions }]"
		(onSelect)="selectPriority($event)"
	></app-dropdown>
</div>
<app-input label="Name(s) of insured" [(ngModel)]="name"></app-input>
<div class="flex gap-2 items-center">
	<app-input label="Policy number" [(ngModel)]="policyNumber"></app-input>
	<app-input
		type="cents"
		label="Insured amount"
		[(ngModel)]="insuredAmount"
	></app-input>
</div>
<div class="flex justify-between items-center mt-6">
	<app-button btn="secondary" (click)="close()" size="small">Close</app-button>
	<app-button *ngIf="!editing" size="small" (click)="addPolicy()" size="small"
		>Add policy</app-button
	>
	<app-button *ngIf="editing" size="small" (click)="addPolicy()" size="small"
		>Save</app-button
	>
</div>
